import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsDownRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.96 15.84h12.88V2.96l-3.36 3.377L6.32.16L.16 6.32l6.16 6.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsDownRight
